
        <div class="date-cell">
            <label>{{ getFormattedDate() }}</label>
        </div>
    